export default __webpack_public_path__ + "static/media/warehouse_white.4486dacc.svg";